import {Card, Row, Tag} from "antd";
import { styled } from "styled-components";

export const StyledCard = styled(Card)`
    border-radius: 10px;
height: 110px;
    .ant-card-body {
    padding: 5px;
  }
`;
export const StyledTag = styled(Tag)`
    display: flex;
    align-items: center;
    font-size: 8px;
    height: 14px;
font-weight: bold;
    border: none;
background-color: var(--thirdColor);
    color: var(--customWhite);
`;
export const StyledRentTypeTag = styled(Tag)`
    font-size: 7px;
    font-weight: bold;
    border: none;
    border-radius: 13px;
background-color: var(--secondColor);
    color: var(--customWhite);
`;
